module.exports = __webpack_public_path__ + "img/bills-icon.6385a9dc.svg";